// extracted by mini-css-extract-plugin
export var deleteModal = "_is-0";